import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["candleCheckbox", "selectAllCheckbox", "createBatchButton"]

  connect() {
    this.updateButton()
  }

  toggleAll(event) {
    const checked = event.target.checked
    this.candleCheckboxTargets.forEach(checkbox => {
      checkbox.checked = checked
    })
    this.updateButton()
  }

  updateButton() {
    const anyChecked = this.candleCheckboxTargets.some(checkbox => checkbox.checked)
    this.createBatchButtonTarget.disabled = !anyChecked

    if (this.hasSelectAllCheckboxTarget) {
      const allChecked = this.candleCheckboxTargets.length > 0 &&
                        this.candleCheckboxTargets.every(checkbox => checkbox.checked)
      const someChecked = this.candleCheckboxTargets.some(checkbox => checkbox.checked)

      this.selectAllCheckboxTarget.checked = allChecked
      this.selectAllCheckboxTarget.indeterminate = someChecked && !allChecked
    }
  }

  createBatch() {
    const selectedCandleIds = this.candleCheckboxTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.dataset.candleId)

    if (selectedCandleIds.length === 0) {
      return
    }

    const url = new URL('/crafting/object_batches/new?object_type=perfumed_candle', window.location.origin)
    url.searchParams.append('perfumed_candle_ids', selectedCandleIds.join(','))
    window.location.href = url.toString()
  }
}

